import script from "./ChessBoard.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChessBoard.vue?vue&type=script&lang=ts&setup=true"

import "./ChessBoard.vue?vue&type=style&index=0&id=74a5422c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\git\\git\\chess-com-frontend-test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74a5422c"]])

export default __exports__